(function() {
    var clearScreen = function(eventName) {
        var eventName = eventName ? '.' + eventName : '';
        var pos = SR.state.hasHistory ? 20 : 0;
        $('.history-wrapper').empty();
        $('.history-placeholder').empty().append('<div class="tip" style="display: block;">上滑加载历史</div>');
        $('.msg').remove();
        setTimeout(function() {
            // 避免定位失效的问题
            SR.dom.$scrollWrap.scrollTop(pos - 5);
        }, 10);
        setTimeout(function() {
            SR.dom.$scrollWrap.scrollTop(pos);
        }, 20);
        SR.data.historyIndex = 0;   // 重置历史加载序列
        SR.App.trigger('cls');
        SR.state.isDebug && console.log('cls' + eventName);
    }
    window.cls = clearScreen;
})();